import { render } from "./FormGroupInput.vue?vue&type=template&id=5950e1fe"
import script from "./FormGroupInput.vue?vue&type=script&lang=js"
export * from "./FormGroupInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__